{
  "id": "campaign-018",
  "name": "Misty Lot",
  "seed": "campaign:18",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "........HHHH",
    "........HHHH",
    "....*...____",
    "...***._...#",
    "......._....",
    ".....h._....",
    ".#....._....",
    "......._....",
    ".....B._....",
    ".....~~_..#.",
    ".....~._.x..",
    "......._....",
    "......h_....",
    "........~...",
    "...........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 4,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 7
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 1,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 0,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 9
    }
  ],
  "generatorVersion": 3,
  "level": 18,
  "biome": "backyard",
  "par": {
    "reel": 5265,
    "push": 4680,
    "selfPropelled": 4308,
    "tractor": 3950,
    "zeroTurn": 2984,
    "fairway": 1551
  },
  "routeTries": {
    "par": {
      "reel": 2,
      "push": 10,
      "selfPropelled": 3,
      "tractor": 0,
      "zeroTurn": 6,
      "fairway": 7
    }
  }
}
